export default class ControlPoint extends PIXI.Sprite {
    constructor(texture = PIXI.Texture.WHITE) {
        super(texture);
        this.anchor.set(0.5);
        this.tint = 0xd3d3d3;

        this._down = false;

        this.buttonMode = true;
        this.interactive = true;
        this.mousedown = this.onDown.bind(this);
        this.mouseup = this.onUp.bind(this);
        this.mousemove = this.onMove.bind(this);
    }

    onDown(event) {
        this._down = true;
    }

    onUp(event) {
        this._down = false;
    }

    onMove(event) {
        if (this._down) {
            this.position = event.data.getLocalPosition(this.parent);
        }
    }
}